
import React from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface StaticTextFiltersProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedPage: string;
  setSelectedPage: (page: string) => void;
  selectedSection: string;
  setSelectedSection: (section: string) => void;
  pages: string[];
  sections: string[];
}

const StaticTextFilters: React.FC<StaticTextFiltersProps> = ({
  searchTerm,
  setSearchTerm,
  selectedPage,
  setSelectedPage,
  selectedSection,
  setSelectedSection,
  pages,
  sections
}) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <div className="flex items-center bg-white rounded-lg shadow p-2 flex-1">
        <Search className="w-5 h-5 text-gray-400 ml-2" />
        <Input
          className="border-0 focus-visible:ring-0"
          placeholder="Buscar por chave ou conteúdo..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      
      <div className="flex gap-4">
        <Select value={selectedPage} onValueChange={setSelectedPage}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Filtrar por página" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all-pages">Todas as páginas</SelectItem>
            {pages.map(page => (
              <SelectItem key={page} value={page}>{page}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        
        <Select 
          value={selectedSection} 
          onValueChange={setSelectedSection}
          disabled={!selectedPage}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Filtrar por seção" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all-sections">Todas as seções</SelectItem>
            {sections.map(section => (
              <SelectItem key={section} value={section}>{section}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default StaticTextFilters;
